import React, { useState , useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';


const ChangePassword = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState(''); // New state for confirm password
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();
  
    useEffect(() => {
      // Scroll to the top of the page when the component loads
      window.scrollTo(0, 0);
    }, []);

    const handleChangePassword = async (e) => {
      e.preventDefault();
  
      // Validate that new passwords match
      if (newPassword !== confirmNewPassword) {
        setError('New passwords do not match.');
        return;
      }
  
      try {
        const token = localStorage.getItem('token'); // JWT token for authentication
  
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/password/change`,
          { current_password: currentPassword, new_password: newPassword },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
  
        console.log('Password changed successfully:', response.data);
        setSuccess('Password changed successfully!');
        setError('');
        setCurrentPassword('');
        setNewPassword('');
        setConfirmNewPassword('');
  
        // Redirect to the dashboard after 5 seconds
        setTimeout(() => {
          navigate('/dashboard');
        }, 5000);
      } catch (err) {
        console.error('Error changing password:', err);
        setError(err.response?.data?.error || 'Failed to change password.');
        setSuccess('');
      }
    };
  
    return (
      <div
        style={{
          padding: '20px',
          fontFamily: 'Arial, sans-serif',
          color: '#333',
          background: 'linear-gradient(to bottom, #f0f8ff, #d6eaff)', // Light gradient background
          minHeight: '100vh', // Full viewport height
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            backgroundColor: '#ffffff', // White card background
            padding: '30px',
            borderRadius: '15px', // Rounded corners
            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)', // Subtle shadow for depth
            width: '100%',
            maxWidth: '400px',
            textAlign: 'center',
          }}
        >
          <h1 style={{ color: '#007bff', marginBottom: '20px', fontSize: '2rem' }}>Change Password</h1>
          {error && (
            <p
              style={{
                color: '#ff4500', // Red for error
                fontWeight: 'bold',
                marginBottom: '15px',
              }}
            >
              {error}
            </p>
          )}
          {success && (
            <p
              style={{
                color: '#28a745', // Green for success
                fontWeight: 'bold',
                marginBottom: '15px',
              }}
            >
              {success}
            </p>
          )}
          <form
            onSubmit={handleChangePassword}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '15px',
            }}
          >
            <div>
              <label
                style={{
                  display: 'block',
                  marginBottom: '5px',
                  fontWeight: 'bold',
                  color: '#333',
                }}
              >
                Current Password:
              </label>
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
                style={{
                  width: '95%',
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '5px',
                  fontSize: '16px',
                  boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
                }}
              />
            </div>
            <div>
              <label
                style={{
                  display: 'block',
                  marginBottom: '5px',
                  fontWeight: 'bold',
                  color: '#333',
                }}
              >
                New Password:
              </label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                style={{
                  width: '95%',
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '5px',
                  fontSize: '16px',
                  boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
                }}
              />
            </div>
            <div>
              <label
                style={{
                  display: 'block',
                  marginBottom: '5px',
                  fontWeight: 'bold',
                  color: '#333',
                }}
              >
                Confirm New Password:
              </label>
              <input
                type="password"
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                required
                style={{
                  width: '95%',
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '5px',
                  fontSize: '16px',
                  boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
                }}
              />
            </div>
            <button
              type="submit"
              style={{
                padding: '12px 20px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                fontSize: '16px',
                cursor: 'pointer',
                transition: 'background-color 0.3s',
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = '#0056b3')}
              onMouseLeave={(e) => (e.target.style.backgroundColor = '#007bff')}
            >
              Change Password
            </button>
          </form>
          <button
            onClick={() => navigate('/dashboard')}
            style={{
              marginTop: '20px',
              padding: '12px 20px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              fontSize: '16px',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = '#5a6268')}
            onMouseLeave={(e) => (e.target.style.backgroundColor = '#6c757d')}
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    );
  };

export default ChangePassword;